import { CustomObject, CustomObjectResponse, ListCustomObjectFieldsResponse, ListCustomObjectsResponse } from "../types/CustomObjects";
import { zendeskRequest } from "./zendesk";

export function createCustomObject(
  data: CustomObject
): Promise<CustomObjectResponse> {
  return zendeskRequest<CustomObjectResponse>(
    "/api/v2/custom_objects",
    "POST",
    { custom_object: data }
  );
}

export async function createCustomObjectField(
  objectKey: string,
  fieldData: any
) {
  return zendeskRequest(`/api/v2/custom_objects/${objectKey}/fields`, "POST", {
    custom_object_field: fieldData,
  });
}

export async function listCustomObjects(): Promise<ListCustomObjectsResponse> {
  return zendeskRequest<ListCustomObjectsResponse>(
    "/api/v2/custom_objects",
    "GET"
  );
}

export async function listCustomObjectFields(
  objectKey: string
): Promise<ListCustomObjectFieldsResponse> {
  return zendeskRequest<ListCustomObjectFieldsResponse>(
    `/api/v2/custom_objects/${objectKey}/fields`,
    "GET"
  );
}

export async function showCustomObject(
  id: string
): Promise<CustomObjectResponse> {
  return zendeskRequest<CustomObjectResponse>(
    `/api/v2/custom_objects/${id}`,
    "GET"
  );
}